import { forwardRef, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { ValidationMessage } from '@clds/form';
import t from 'common/i18n';
import rootActions, { types as rootAts } from 'root/actions';
import LazyMetadataForm from './LazyMetadataForm';
const { [rootAts.SET_METADATA_INFO]: setMetadataInfo } = rootActions.creators;

const FormContainer = styled.div`
  p[type='error'] {
    color: ${({ theme }) => `${theme?.palette?.error}`};
    margin-top: ${({ theme }) => `${theme?.spacing?.xxs}`};
  }
`;

export default forwardRef(({ fields, hasConflicts, layout, setFormRenderError }, formRef) => {
  const dispatch = useDispatch(),
    history = useHistory(),
    [unsupportedMessage, setUnsupportedMessage] = useState(null);

  const handleFormSubmitSuccess = useCallback(
    (values, fieldsMeta) => {
      dispatch(setMetadataInfo({ values, fields: fieldsMeta }));
      history.goBack();
    },
    [history, dispatch]
  );

  const handleFormError = useCallback(
    (fieldsTypeErrorInfo) => {
      let isMandatoryUnsupported = false;

      const errorFields = fieldsTypeErrorInfo?.unsupportedFields;

      if (errorFields && errorFields.length) {
        const unsupportedFieldLabel = errorFields.reduce((res, field) => {
          if (field.mandatory) {
            isMandatoryUnsupported = true;
          }
          return [...res, field?.label];
        }, []);

        setUnsupportedMessage(
          (isMandatoryUnsupported ? t('metadataPage.validationErrors.unsupportedRequiredFields') : t('metadataPage.validationErrors.unsupportedFields')) +
            unsupportedFieldLabel.join(', ')
        );

        if (isMandatoryUnsupported) {
          setFormRenderError(true);
        }
      }
    },
    [setFormRenderError]
  );

  return (
    <FormContainer>
      {unsupportedMessage && <ValidationMessage type="error">{unsupportedMessage}</ValidationMessage>}
      <LazyMetadataForm
        fields={fields}
        layout={layout}
        handleFormSubmitSuccess={handleFormSubmitSuccess}
        hasConflicts={hasConflicts}
        handleFormError={handleFormError}
        formRef={formRef}
      />
    </FormContainer>
  );
});
